import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import axios from "axios";
import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import { sentryLog } from '../Utils/SentryLog';
import ExtensionNavbar from './ExtensionNavbar';

function SheetsExtensionContactUs(){

    const [statusMessage, setStatusMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

    useEffect(() => {
        document.title = "Convert PDF to Google Sheets in 1 click | Convert PDF Bank Statement to CSV | 1-click PDF to Google Sheets Converter, PDF to CSV converter";

        // If Crisp is already loaded, open it immediately
        if (window.$crisp) {
            window.$crisp.push(["do", "chat:open"]);
        } else {
        // If not loaded yet, wait for the ready event
            window.CRISP_READY_TRIGGER = () => {
                window.$crisp.push(["do", "chat:open"]);
            };
        }
    }, []);

    useEffect(() => {
        if(statusMessage !== ""){
            setTimeout(() => {
                setStatusMessage("");
                setIsSuccess(false);
            }, 4000);
        }
    }, [statusMessage])

    const handleFormSubmit = async(e) => {
        e.preventDefault();
        setIsLoading(true);
        const formData = {
            name: DOMPurify.sanitize(e.target.name.value),
            email: DOMPurify.sanitize(e.target.email.value),
            message: DOMPurify.sanitize(e.target.message.value),
            extraInfo: e.target.extraInfo.value
        };
        isShowConsole && console.log('form submitted: ', formData);

        try {
            const res = await axios.post(`${API_BASE_URL}/api/contact`, formData);
    
            if (res.data.success) {
                setStatusMessage(res.data.message);
                e.target.reset();
                setIsSuccess(true);
                setIsLoading(false);
            } else {
                setStatusMessage(res.data.error || 'Failed to send message.');
                setIsSuccess(false);
                setIsLoading(false);
            }
        } catch (err) {
            isShowConsole && console.error('Error submitting form:', err);
            sentryLog(`SheetsExtensionContactUs.js - /api/contact failed: ${err?.message || err}`);
            setStatusMessage((err.response && err.response.data && err.response.data.error) || "Something went wrong. Please try again later.");
            setIsSuccess(false);
            setIsLoading(false);
        }
    }

    return(
        <div className='parentDiv'>
            <div className='mainDiv contactUs'>
                <div className='header'>
                    <ExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>
                            <div className='main'>Contact Us</div>
                            <div className='sub'>Reach out to us with your queries or feedback</div>
                        </div>
                        <div className='contentBox'>
                            <div className='content'>
                                <form onSubmit={handleFormSubmit}>
                                    <div className='userDetails'>
                                        <div>
                                            <label htmlFor="name">Name:</label><br/>
                                            <input className='nameInput' type="text" id="name" name="name" required/>
                                        </div>
                                        <div>
                                            <label htmlFor="email">Email:</label><br/>
                                            <input className='emailInput' type="email" id="email" name="email" required/>
                                        </div>
                                    </div>
                                    <div className='messageContainer'>
                                        <label htmlFor="message">Message:</label><br/>
                                        <textarea id="message" name="message" rows="6" cols="61" required></textarea>
                                    </div>
                                    <input
                                        type="text"
                                        name="extraInfo"
                                        className="hiddenInput"
                                        style={{ display: "none" }}
                                        tabIndex="-1"
                                        autoComplete="off"
                                    />
                                    <div className='submitDiv'>
                                        <button disabled={isLoading} className={`submitBtn ${isLoading ? 'disabled' : ''}`} type="submit">Submit</button>
                                    </div>
                                </form>
                                {statusMessage && 
                                    <div className='statusMsgCont'>
                                        <div className={`statusMessage ${isSuccess ? 'success' : 'failure'}`}>{statusMessage}</div>
                                    </div>
                                }
                                {isLoading && 
                                    <div className='loaderDiv'>
                                        Sending...
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default SheetsExtensionContactUs;